// GET api/console/me — identity and authorization snapshot for the signed-in console user.
//
// Task 326.17 (decision Q27): permission codes moved off the JWT. The token carries roles only;
// the console asks the BFF for its codes, which resolves them per request from the grant tables the
// server itself enforces on. Consequence: what the UI offers and what the API allows cannot drift,
// and a revoked grant disappears on the next /me instead of surviving until the token expires.

import { api } from '../client';

export interface MeResponse {
  userId: string;
  tenantId: string | null;
  username: string;
  email: string | null;
  fullName: string | null;
  /** Role codes (SYSTEM_ADMIN, TENANT_ADMIN, …). NOT permission codes. */
  roles: string[];
  /** Permission codes the caller holds. */
  permissions: string[];
}

export async function getMe(): Promise<MeResponse> {
  return api.get<MeResponse>('api/console/me');
}
